/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as SignInRouteRouteImport } from './routes/sign-in/route'
import { Route as SignInAsRouteImport } from './routes/sign-in-as'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as DashboardMailRouteRouteImport } from './routes/_dashboard/mail/route'
import { Route as DashboardMailboxRouteRouteImport } from './routes/_dashboard/mailbox/route'
import { Route as DashboardSettingsRouteRouteImport } from './routes/_dashboard/settings/route'
import { Route as DashboardTasksRouteRouteImport } from './routes/_dashboard/tasks/route'
import { Route as DashboardCallSimulationIndexRouteImport } from './routes/_dashboard/call-simulation/index'
import { Route as DashboardMailIndexRouteImport } from './routes/_dashboard/mail/index'
import { Route as DashboardMailFolderRouteRouteImport } from './routes/_dashboard/mail/$folder/route'
import { Route as DashboardMailNewMessageRouteImport } from './routes/_dashboard/mail/new-message'
import { Route as DashboardMailboxIndexRouteImport } from './routes/_dashboard/mailbox/index'
import { Route as DashboardMailboxFolderRouteRouteImport } from './routes/_dashboard/mailbox/$folder/route'
import { Route as DashboardMailboxIncomingRouteRouteImport } from './routes/_dashboard/mailbox/incoming/route'
import { Route as DashboardMailboxNewMessageRouteImport } from './routes/_dashboard/mailbox/new-message'
import { Route as DashboardMailboxSentRouteRouteImport } from './routes/_dashboard/mailbox/sent/route'
import { Route as DashboardSettingsIndexRouteImport } from './routes/_dashboard/settings/index'
import { Route as DashboardSettingsAccountRouteImport } from './routes/_dashboard/settings/account'
import { Route as DashboardSettingsCallsRouteImport } from './routes/_dashboard/settings/calls'
import { Route as DashboardSettingsGoogleWorkspaceRouteImport } from './routes/_dashboard/settings/google-workspace'
import { Route as DashboardSettingsNotificationsRouteImport } from './routes/_dashboard/settings/notifications'
import { Route as DashboardSettingsShiftsRouteImport } from './routes/_dashboard/settings/shifts'
import { Route as DashboardSettingsUsersRouteImport } from './routes/_dashboard/settings/users'
import { Route as DashboardSettingsWorkHoursRouteImport } from './routes/_dashboard/settings/work-hours'
import { Route as DashboardTasksIndexRouteImport } from './routes/_dashboard/tasks/index'
import { Route as DashboardTasksContactIdRouteImport } from './routes/_dashboard/tasks/$contactId'
import { Route as DashboardMailFolderIndexRouteImport } from './routes/_dashboard/mail/$folder/index'
import { Route as DashboardMailFolderThreadIdRouteImport } from './routes/_dashboard/mail/$folder/$threadId'
import { Route as DashboardMailboxFolderIndexRouteImport } from './routes/_dashboard/mailbox/$folder/index'
import { Route as DashboardMailboxFolderEmailIdRouteImport } from './routes/_dashboard/mailbox/$folder/$emailId'
import { Route as DashboardMailboxIncomingIndexRouteImport } from './routes/_dashboard/mailbox/incoming/index'
import { Route as DashboardMailboxIncomingThreadIdRouteImport } from './routes/_dashboard/mailbox/incoming/$threadId'
import { Route as DashboardMailboxSentIndexRouteImport } from './routes/_dashboard/mailbox/sent/index'
import { Route as DashboardMailboxSentEmailIdRouteImport } from './routes/_dashboard/mailbox/sent/$emailId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRouteRoute = SignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInAsRoute = SignInAsRouteImport.update({
  id: '/sign-in-as',
  path: '/sign-in-as',
  getParentRoute: () => rootRouteImport,
} as any)
const SignOutRoute = SignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardMailRouteRoute = DashboardMailRouteRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMailboxRouteRoute = DashboardMailboxRouteRouteImport.update({
  id: '/mailbox',
  path: '/mailbox',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTasksRouteRoute = DashboardTasksRouteRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCallSimulationIndexRoute =
  DashboardCallSimulationIndexRouteImport.update({
    id: '/call-simulation/',
    path: '/call-simulation/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardMailIndexRoute = DashboardMailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardMailRouteRoute,
} as any)
const DashboardMailFolderRouteRoute =
  DashboardMailFolderRouteRouteImport.update({
    id: '/$folder',
    path: '/$folder',
    getParentRoute: () => DashboardMailRouteRoute,
  } as any)
const DashboardMailNewMessageRoute = DashboardMailNewMessageRouteImport.update({
  id: '/new-message',
  path: '/new-message',
  getParentRoute: () => DashboardMailRouteRoute,
} as any)
const DashboardMailboxIndexRoute = DashboardMailboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardMailboxRouteRoute,
} as any)
const DashboardMailboxFolderRouteRoute =
  DashboardMailboxFolderRouteRouteImport.update({
    id: '/$folder',
    path: '/$folder',
    getParentRoute: () => DashboardMailboxRouteRoute,
  } as any)
const DashboardMailboxIncomingRouteRoute =
  DashboardMailboxIncomingRouteRouteImport.update({
    id: '/incoming',
    path: '/incoming',
    getParentRoute: () => DashboardMailboxRouteRoute,
  } as any)
const DashboardMailboxNewMessageRoute =
  DashboardMailboxNewMessageRouteImport.update({
    id: '/new-message',
    path: '/new-message',
    getParentRoute: () => DashboardMailboxRouteRoute,
  } as any)
const DashboardMailboxSentRouteRoute =
  DashboardMailboxSentRouteRouteImport.update({
    id: '/sent',
    path: '/sent',
    getParentRoute: () => DashboardMailboxRouteRoute,
  } as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardSettingsAccountRoute =
  DashboardSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardSettingsCallsRoute = DashboardSettingsCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardSettingsGoogleWorkspaceRoute =
  DashboardSettingsGoogleWorkspaceRouteImport.update({
    id: '/google-workspace',
    path: '/google-workspace',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardSettingsNotificationsRoute =
  DashboardSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardSettingsShiftsRoute = DashboardSettingsShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardSettingsUsersRoute = DashboardSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardSettingsWorkHoursRoute =
  DashboardSettingsWorkHoursRouteImport.update({
    id: '/work-hours',
    path: '/work-hours',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardTasksIndexRoute = DashboardTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardTasksRouteRoute,
} as any)
const DashboardTasksContactIdRoute = DashboardTasksContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => DashboardTasksRouteRoute,
} as any)
const DashboardMailFolderIndexRoute =
  DashboardMailFolderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardMailFolderRouteRoute,
  } as any)
const DashboardMailFolderThreadIdRoute =
  DashboardMailFolderThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => DashboardMailFolderRouteRoute,
  } as any)
const DashboardMailboxFolderIndexRoute =
  DashboardMailboxFolderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardMailboxFolderRouteRoute,
  } as any)
const DashboardMailboxFolderEmailIdRoute =
  DashboardMailboxFolderEmailIdRouteImport.update({
    id: '/$emailId',
    path: '/$emailId',
    getParentRoute: () => DashboardMailboxFolderRouteRoute,
  } as any)
const DashboardMailboxIncomingIndexRoute =
  DashboardMailboxIncomingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardMailboxIncomingRouteRoute,
  } as any)
const DashboardMailboxIncomingThreadIdRoute =
  DashboardMailboxIncomingThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => DashboardMailboxIncomingRouteRoute,
  } as any)
const DashboardMailboxSentIndexRoute =
  DashboardMailboxSentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardMailboxSentRouteRoute,
  } as any)
const DashboardMailboxSentEmailIdRoute =
  DashboardMailboxSentEmailIdRouteImport.update({
    id: '/$emailId',
    path: '/$emailId',
    getParentRoute: () => DashboardMailboxSentRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRouteRoute
  '/sign-in-as': typeof SignInAsRoute
  '/sign-out': typeof SignOutRoute
  '/two-factor': typeof TwoFactorRoute
  '/mail': typeof DashboardMailRouteRouteWithChildren
  '/mailbox': typeof DashboardMailboxRouteRouteWithChildren
  '/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/tasks': typeof DashboardTasksRouteRouteWithChildren
  '/mail/$folder': typeof DashboardMailFolderRouteRouteWithChildren
  '/mailbox/$folder': typeof DashboardMailboxFolderRouteRouteWithChildren
  '/mailbox/incoming': typeof DashboardMailboxIncomingRouteRouteWithChildren
  '/mailbox/sent': typeof DashboardMailboxSentRouteRouteWithChildren
  '/mail/new-message': typeof DashboardMailNewMessageRoute
  '/mailbox/new-message': typeof DashboardMailboxNewMessageRoute
  '/settings/account': typeof DashboardSettingsAccountRoute
  '/settings/calls': typeof DashboardSettingsCallsRoute
  '/settings/google-workspace': typeof DashboardSettingsGoogleWorkspaceRoute
  '/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/settings/shifts': typeof DashboardSettingsShiftsRoute
  '/settings/users': typeof DashboardSettingsUsersRoute
  '/settings/work-hours': typeof DashboardSettingsWorkHoursRoute
  '/tasks/$contactId': typeof DashboardTasksContactIdRoute
  '/call-simulation/': typeof DashboardCallSimulationIndexRoute
  '/mail/': typeof DashboardMailIndexRoute
  '/mailbox/': typeof DashboardMailboxIndexRoute
  '/settings/': typeof DashboardSettingsIndexRoute
  '/tasks/': typeof DashboardTasksIndexRoute
  '/mail/$folder/$threadId': typeof DashboardMailFolderThreadIdRoute
  '/mailbox/$folder/$emailId': typeof DashboardMailboxFolderEmailIdRoute
  '/mailbox/incoming/$threadId': typeof DashboardMailboxIncomingThreadIdRoute
  '/mailbox/sent/$emailId': typeof DashboardMailboxSentEmailIdRoute
  '/mail/$folder/': typeof DashboardMailFolderIndexRoute
  '/mailbox/$folder/': typeof DashboardMailboxFolderIndexRoute
  '/mailbox/incoming/': typeof DashboardMailboxIncomingIndexRoute
  '/mailbox/sent/': typeof DashboardMailboxSentIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRouteRoute
  '/sign-in-as': typeof SignInAsRoute
  '/sign-out': typeof SignOutRoute
  '/two-factor': typeof TwoFactorRoute
  '/mail/new-message': typeof DashboardMailNewMessageRoute
  '/mailbox/new-message': typeof DashboardMailboxNewMessageRoute
  '/settings/account': typeof DashboardSettingsAccountRoute
  '/settings/calls': typeof DashboardSettingsCallsRoute
  '/settings/google-workspace': typeof DashboardSettingsGoogleWorkspaceRoute
  '/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/settings/shifts': typeof DashboardSettingsShiftsRoute
  '/settings/users': typeof DashboardSettingsUsersRoute
  '/settings/work-hours': typeof DashboardSettingsWorkHoursRoute
  '/tasks/$contactId': typeof DashboardTasksContactIdRoute
  '/call-simulation': typeof DashboardCallSimulationIndexRoute
  '/mail': typeof DashboardMailIndexRoute
  '/mailbox': typeof DashboardMailboxIndexRoute
  '/settings': typeof DashboardSettingsIndexRoute
  '/tasks': typeof DashboardTasksIndexRoute
  '/mail/$folder/$threadId': typeof DashboardMailFolderThreadIdRoute
  '/mailbox/$folder/$emailId': typeof DashboardMailboxFolderEmailIdRoute
  '/mailbox/incoming/$threadId': typeof DashboardMailboxIncomingThreadIdRoute
  '/mailbox/sent/$emailId': typeof DashboardMailboxSentEmailIdRoute
  '/mail/$folder': typeof DashboardMailFolderIndexRoute
  '/mailbox/$folder': typeof DashboardMailboxFolderIndexRoute
  '/mailbox/incoming': typeof DashboardMailboxIncomingIndexRoute
  '/mailbox/sent': typeof DashboardMailboxSentIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/sign-in': typeof SignInRouteRoute
  '/sign-in-as': typeof SignInAsRoute
  '/sign-out': typeof SignOutRoute
  '/two-factor': typeof TwoFactorRoute
  '/_dashboard/mail': typeof DashboardMailRouteRouteWithChildren
  '/_dashboard/mailbox': typeof DashboardMailboxRouteRouteWithChildren
  '/_dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/_dashboard/tasks': typeof DashboardTasksRouteRouteWithChildren
  '/_dashboard/mail/$folder': typeof DashboardMailFolderRouteRouteWithChildren
  '/_dashboard/mailbox/$folder': typeof DashboardMailboxFolderRouteRouteWithChildren
  '/_dashboard/mailbox/incoming': typeof DashboardMailboxIncomingRouteRouteWithChildren
  '/_dashboard/mailbox/sent': typeof DashboardMailboxSentRouteRouteWithChildren
  '/_dashboard/mail/new-message': typeof DashboardMailNewMessageRoute
  '/_dashboard/mailbox/new-message': typeof DashboardMailboxNewMessageRoute
  '/_dashboard/settings/account': typeof DashboardSettingsAccountRoute
  '/_dashboard/settings/calls': typeof DashboardSettingsCallsRoute
  '/_dashboard/settings/google-workspace': typeof DashboardSettingsGoogleWorkspaceRoute
  '/_dashboard/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/_dashboard/settings/shifts': typeof DashboardSettingsShiftsRoute
  '/_dashboard/settings/users': typeof DashboardSettingsUsersRoute
  '/_dashboard/settings/work-hours': typeof DashboardSettingsWorkHoursRoute
  '/_dashboard/tasks/$contactId': typeof DashboardTasksContactIdRoute
  '/_dashboard/call-simulation/': typeof DashboardCallSimulationIndexRoute
  '/_dashboard/mail/': typeof DashboardMailIndexRoute
  '/_dashboard/mailbox/': typeof DashboardMailboxIndexRoute
  '/_dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/_dashboard/tasks/': typeof DashboardTasksIndexRoute
  '/_dashboard/mail/$folder/$threadId': typeof DashboardMailFolderThreadIdRoute
  '/_dashboard/mailbox/$folder/$emailId': typeof DashboardMailboxFolderEmailIdRoute
  '/_dashboard/mailbox/incoming/$threadId': typeof DashboardMailboxIncomingThreadIdRoute
  '/_dashboard/mailbox/sent/$emailId': typeof DashboardMailboxSentEmailIdRoute
  '/_dashboard/mail/$folder/': typeof DashboardMailFolderIndexRoute
  '/_dashboard/mailbox/$folder/': typeof DashboardMailboxFolderIndexRoute
  '/_dashboard/mailbox/incoming/': typeof DashboardMailboxIncomingIndexRoute
  '/_dashboard/mailbox/sent/': typeof DashboardMailboxSentIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-in-as'
    | '/sign-out'
    | '/two-factor'
    | '/mail'
    | '/mailbox'
    | '/settings'
    | '/tasks'
    | '/mail/$folder'
    | '/mailbox/$folder'
    | '/mailbox/incoming'
    | '/mailbox/sent'
    | '/mail/new-message'
    | '/mailbox/new-message'
    | '/settings/account'
    | '/settings/calls'
    | '/settings/google-workspace'
    | '/settings/notifications'
    | '/settings/shifts'
    | '/settings/users'
    | '/settings/work-hours'
    | '/tasks/$contactId'
    | '/call-simulation/'
    | '/mail/'
    | '/mailbox/'
    | '/settings/'
    | '/tasks/'
    | '/mail/$folder/$threadId'
    | '/mailbox/$folder/$emailId'
    | '/mailbox/incoming/$threadId'
    | '/mailbox/sent/$emailId'
    | '/mail/$folder/'
    | '/mailbox/$folder/'
    | '/mailbox/incoming/'
    | '/mailbox/sent/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-in-as'
    | '/sign-out'
    | '/two-factor'
    | '/mail/new-message'
    | '/mailbox/new-message'
    | '/settings/account'
    | '/settings/calls'
    | '/settings/google-workspace'
    | '/settings/notifications'
    | '/settings/shifts'
    | '/settings/users'
    | '/settings/work-hours'
    | '/tasks/$contactId'
    | '/call-simulation'
    | '/mail'
    | '/mailbox'
    | '/settings'
    | '/tasks'
    | '/mail/$folder/$threadId'
    | '/mailbox/$folder/$emailId'
    | '/mailbox/incoming/$threadId'
    | '/mailbox/sent/$emailId'
    | '/mail/$folder'
    | '/mailbox/$folder'
    | '/mailbox/incoming'
    | '/mailbox/sent'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/sign-in'
    | '/sign-in-as'
    | '/sign-out'
    | '/two-factor'
    | '/_dashboard/mail'
    | '/_dashboard/mailbox'
    | '/_dashboard/settings'
    | '/_dashboard/tasks'
    | '/_dashboard/mail/$folder'
    | '/_dashboard/mailbox/$folder'
    | '/_dashboard/mailbox/incoming'
    | '/_dashboard/mailbox/sent'
    | '/_dashboard/mail/new-message'
    | '/_dashboard/mailbox/new-message'
    | '/_dashboard/settings/account'
    | '/_dashboard/settings/calls'
    | '/_dashboard/settings/google-workspace'
    | '/_dashboard/settings/notifications'
    | '/_dashboard/settings/shifts'
    | '/_dashboard/settings/users'
    | '/_dashboard/settings/work-hours'
    | '/_dashboard/tasks/$contactId'
    | '/_dashboard/call-simulation/'
    | '/_dashboard/mail/'
    | '/_dashboard/mailbox/'
    | '/_dashboard/settings/'
    | '/_dashboard/tasks/'
    | '/_dashboard/mail/$folder/$threadId'
    | '/_dashboard/mailbox/$folder/$emailId'
    | '/_dashboard/mailbox/incoming/$threadId'
    | '/_dashboard/mailbox/sent/$emailId'
    | '/_dashboard/mail/$folder/'
    | '/_dashboard/mailbox/$folder/'
    | '/_dashboard/mailbox/incoming/'
    | '/_dashboard/mailbox/sent/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  SignInRouteRoute: typeof SignInRouteRoute
  SignInAsRoute: typeof SignInAsRoute
  SignOutRoute: typeof SignOutRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in-as': {
      id: '/sign-in-as'
      path: '/sign-in-as'
      fullPath: '/sign-in-as'
      preLoaderRoute: typeof SignInAsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/mail': {
      id: '/_dashboard/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof DashboardMailRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/mailbox': {
      id: '/_dashboard/mailbox'
      path: '/mailbox'
      fullPath: '/mailbox'
      preLoaderRoute: typeof DashboardMailboxRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/tasks': {
      id: '/_dashboard/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof DashboardTasksRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/call-simulation/': {
      id: '/_dashboard/call-simulation/'
      path: '/call-simulation'
      fullPath: '/call-simulation/'
      preLoaderRoute: typeof DashboardCallSimulationIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/mail/': {
      id: '/_dashboard/mail/'
      path: '/'
      fullPath: '/mail/'
      preLoaderRoute: typeof DashboardMailIndexRouteImport
      parentRoute: typeof DashboardMailRouteRoute
    }
    '/_dashboard/mail/$folder': {
      id: '/_dashboard/mail/$folder'
      path: '/$folder'
      fullPath: '/mail/$folder'
      preLoaderRoute: typeof DashboardMailFolderRouteRouteImport
      parentRoute: typeof DashboardMailRouteRoute
    }
    '/_dashboard/mail/new-message': {
      id: '/_dashboard/mail/new-message'
      path: '/new-message'
      fullPath: '/mail/new-message'
      preLoaderRoute: typeof DashboardMailNewMessageRouteImport
      parentRoute: typeof DashboardMailRouteRoute
    }
    '/_dashboard/mailbox/': {
      id: '/_dashboard/mailbox/'
      path: '/'
      fullPath: '/mailbox/'
      preLoaderRoute: typeof DashboardMailboxIndexRouteImport
      parentRoute: typeof DashboardMailboxRouteRoute
    }
    '/_dashboard/mailbox/$folder': {
      id: '/_dashboard/mailbox/$folder'
      path: '/$folder'
      fullPath: '/mailbox/$folder'
      preLoaderRoute: typeof DashboardMailboxFolderRouteRouteImport
      parentRoute: typeof DashboardMailboxRouteRoute
    }
    '/_dashboard/mailbox/incoming': {
      id: '/_dashboard/mailbox/incoming'
      path: '/incoming'
      fullPath: '/mailbox/incoming'
      preLoaderRoute: typeof DashboardMailboxIncomingRouteRouteImport
      parentRoute: typeof DashboardMailboxRouteRoute
    }
    '/_dashboard/mailbox/new-message': {
      id: '/_dashboard/mailbox/new-message'
      path: '/new-message'
      fullPath: '/mailbox/new-message'
      preLoaderRoute: typeof DashboardMailboxNewMessageRouteImport
      parentRoute: typeof DashboardMailboxRouteRoute
    }
    '/_dashboard/mailbox/sent': {
      id: '/_dashboard/mailbox/sent'
      path: '/sent'
      fullPath: '/mailbox/sent'
      preLoaderRoute: typeof DashboardMailboxSentRouteRouteImport
      parentRoute: typeof DashboardMailboxRouteRoute
    }
    '/_dashboard/settings/': {
      id: '/_dashboard/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/account': {
      id: '/_dashboard/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof DashboardSettingsAccountRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/calls': {
      id: '/_dashboard/settings/calls'
      path: '/calls'
      fullPath: '/settings/calls'
      preLoaderRoute: typeof DashboardSettingsCallsRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/google-workspace': {
      id: '/_dashboard/settings/google-workspace'
      path: '/google-workspace'
      fullPath: '/settings/google-workspace'
      preLoaderRoute: typeof DashboardSettingsGoogleWorkspaceRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/notifications': {
      id: '/_dashboard/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof DashboardSettingsNotificationsRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/shifts': {
      id: '/_dashboard/settings/shifts'
      path: '/shifts'
      fullPath: '/settings/shifts'
      preLoaderRoute: typeof DashboardSettingsShiftsRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/users': {
      id: '/_dashboard/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof DashboardSettingsUsersRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/settings/work-hours': {
      id: '/_dashboard/settings/work-hours'
      path: '/work-hours'
      fullPath: '/settings/work-hours'
      preLoaderRoute: typeof DashboardSettingsWorkHoursRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/_dashboard/tasks/': {
      id: '/_dashboard/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof DashboardTasksIndexRouteImport
      parentRoute: typeof DashboardTasksRouteRoute
    }
    '/_dashboard/tasks/$contactId': {
      id: '/_dashboard/tasks/$contactId'
      path: '/$contactId'
      fullPath: '/tasks/$contactId'
      preLoaderRoute: typeof DashboardTasksContactIdRouteImport
      parentRoute: typeof DashboardTasksRouteRoute
    }
    '/_dashboard/mail/$folder/': {
      id: '/_dashboard/mail/$folder/'
      path: '/'
      fullPath: '/mail/$folder/'
      preLoaderRoute: typeof DashboardMailFolderIndexRouteImport
      parentRoute: typeof DashboardMailFolderRouteRoute
    }
    '/_dashboard/mail/$folder/$threadId': {
      id: '/_dashboard/mail/$folder/$threadId'
      path: '/$threadId'
      fullPath: '/mail/$folder/$threadId'
      preLoaderRoute: typeof DashboardMailFolderThreadIdRouteImport
      parentRoute: typeof DashboardMailFolderRouteRoute
    }
    '/_dashboard/mailbox/$folder/': {
      id: '/_dashboard/mailbox/$folder/'
      path: '/'
      fullPath: '/mailbox/$folder/'
      preLoaderRoute: typeof DashboardMailboxFolderIndexRouteImport
      parentRoute: typeof DashboardMailboxFolderRouteRoute
    }
    '/_dashboard/mailbox/$folder/$emailId': {
      id: '/_dashboard/mailbox/$folder/$emailId'
      path: '/$emailId'
      fullPath: '/mailbox/$folder/$emailId'
      preLoaderRoute: typeof DashboardMailboxFolderEmailIdRouteImport
      parentRoute: typeof DashboardMailboxFolderRouteRoute
    }
    '/_dashboard/mailbox/incoming/': {
      id: '/_dashboard/mailbox/incoming/'
      path: '/'
      fullPath: '/mailbox/incoming/'
      preLoaderRoute: typeof DashboardMailboxIncomingIndexRouteImport
      parentRoute: typeof DashboardMailboxIncomingRouteRoute
    }
    '/_dashboard/mailbox/incoming/$threadId': {
      id: '/_dashboard/mailbox/incoming/$threadId'
      path: '/$threadId'
      fullPath: '/mailbox/incoming/$threadId'
      preLoaderRoute: typeof DashboardMailboxIncomingThreadIdRouteImport
      parentRoute: typeof DashboardMailboxIncomingRouteRoute
    }
    '/_dashboard/mailbox/sent/': {
      id: '/_dashboard/mailbox/sent/'
      path: '/'
      fullPath: '/mailbox/sent/'
      preLoaderRoute: typeof DashboardMailboxSentIndexRouteImport
      parentRoute: typeof DashboardMailboxSentRouteRoute
    }
    '/_dashboard/mailbox/sent/$emailId': {
      id: '/_dashboard/mailbox/sent/$emailId'
      path: '/$emailId'
      fullPath: '/mailbox/sent/$emailId'
      preLoaderRoute: typeof DashboardMailboxSentEmailIdRouteImport
      parentRoute: typeof DashboardMailboxSentRouteRoute
    }
  }
}

interface DashboardMailFolderRouteRouteChildren {
  DashboardMailFolderThreadIdRoute: typeof DashboardMailFolderThreadIdRoute
  DashboardMailFolderIndexRoute: typeof DashboardMailFolderIndexRoute
}

const DashboardMailFolderRouteRouteChildren: DashboardMailFolderRouteRouteChildren =
  {
    DashboardMailFolderThreadIdRoute: DashboardMailFolderThreadIdRoute,
    DashboardMailFolderIndexRoute: DashboardMailFolderIndexRoute,
  }

const DashboardMailFolderRouteRouteWithChildren =
  DashboardMailFolderRouteRoute._addFileChildren(
    DashboardMailFolderRouteRouteChildren,
  )

interface DashboardMailRouteRouteChildren {
  DashboardMailFolderRouteRoute: typeof DashboardMailFolderRouteRouteWithChildren
  DashboardMailNewMessageRoute: typeof DashboardMailNewMessageRoute
  DashboardMailIndexRoute: typeof DashboardMailIndexRoute
}

const DashboardMailRouteRouteChildren: DashboardMailRouteRouteChildren = {
  DashboardMailFolderRouteRoute: DashboardMailFolderRouteRouteWithChildren,
  DashboardMailNewMessageRoute: DashboardMailNewMessageRoute,
  DashboardMailIndexRoute: DashboardMailIndexRoute,
}

const DashboardMailRouteRouteWithChildren =
  DashboardMailRouteRoute._addFileChildren(DashboardMailRouteRouteChildren)

interface DashboardMailboxFolderRouteRouteChildren {
  DashboardMailboxFolderEmailIdRoute: typeof DashboardMailboxFolderEmailIdRoute
  DashboardMailboxFolderIndexRoute: typeof DashboardMailboxFolderIndexRoute
}

const DashboardMailboxFolderRouteRouteChildren: DashboardMailboxFolderRouteRouteChildren =
  {
    DashboardMailboxFolderEmailIdRoute: DashboardMailboxFolderEmailIdRoute,
    DashboardMailboxFolderIndexRoute: DashboardMailboxFolderIndexRoute,
  }

const DashboardMailboxFolderRouteRouteWithChildren =
  DashboardMailboxFolderRouteRoute._addFileChildren(
    DashboardMailboxFolderRouteRouteChildren,
  )

interface DashboardMailboxIncomingRouteRouteChildren {
  DashboardMailboxIncomingThreadIdRoute: typeof DashboardMailboxIncomingThreadIdRoute
  DashboardMailboxIncomingIndexRoute: typeof DashboardMailboxIncomingIndexRoute
}

const DashboardMailboxIncomingRouteRouteChildren: DashboardMailboxIncomingRouteRouteChildren =
  {
    DashboardMailboxIncomingThreadIdRoute:
      DashboardMailboxIncomingThreadIdRoute,
    DashboardMailboxIncomingIndexRoute: DashboardMailboxIncomingIndexRoute,
  }

const DashboardMailboxIncomingRouteRouteWithChildren =
  DashboardMailboxIncomingRouteRoute._addFileChildren(
    DashboardMailboxIncomingRouteRouteChildren,
  )

interface DashboardMailboxSentRouteRouteChildren {
  DashboardMailboxSentEmailIdRoute: typeof DashboardMailboxSentEmailIdRoute
  DashboardMailboxSentIndexRoute: typeof DashboardMailboxSentIndexRoute
}

const DashboardMailboxSentRouteRouteChildren: DashboardMailboxSentRouteRouteChildren =
  {
    DashboardMailboxSentEmailIdRoute: DashboardMailboxSentEmailIdRoute,
    DashboardMailboxSentIndexRoute: DashboardMailboxSentIndexRoute,
  }

const DashboardMailboxSentRouteRouteWithChildren =
  DashboardMailboxSentRouteRoute._addFileChildren(
    DashboardMailboxSentRouteRouteChildren,
  )

interface DashboardMailboxRouteRouteChildren {
  DashboardMailboxFolderRouteRoute: typeof DashboardMailboxFolderRouteRouteWithChildren
  DashboardMailboxIncomingRouteRoute: typeof DashboardMailboxIncomingRouteRouteWithChildren
  DashboardMailboxSentRouteRoute: typeof DashboardMailboxSentRouteRouteWithChildren
  DashboardMailboxNewMessageRoute: typeof DashboardMailboxNewMessageRoute
  DashboardMailboxIndexRoute: typeof DashboardMailboxIndexRoute
}

const DashboardMailboxRouteRouteChildren: DashboardMailboxRouteRouteChildren = {
  DashboardMailboxFolderRouteRoute:
    DashboardMailboxFolderRouteRouteWithChildren,
  DashboardMailboxIncomingRouteRoute:
    DashboardMailboxIncomingRouteRouteWithChildren,
  DashboardMailboxSentRouteRoute: DashboardMailboxSentRouteRouteWithChildren,
  DashboardMailboxNewMessageRoute: DashboardMailboxNewMessageRoute,
  DashboardMailboxIndexRoute: DashboardMailboxIndexRoute,
}

const DashboardMailboxRouteRouteWithChildren =
  DashboardMailboxRouteRoute._addFileChildren(
    DashboardMailboxRouteRouteChildren,
  )

interface DashboardSettingsRouteRouteChildren {
  DashboardSettingsAccountRoute: typeof DashboardSettingsAccountRoute
  DashboardSettingsCallsRoute: typeof DashboardSettingsCallsRoute
  DashboardSettingsGoogleWorkspaceRoute: typeof DashboardSettingsGoogleWorkspaceRoute
  DashboardSettingsNotificationsRoute: typeof DashboardSettingsNotificationsRoute
  DashboardSettingsShiftsRoute: typeof DashboardSettingsShiftsRoute
  DashboardSettingsUsersRoute: typeof DashboardSettingsUsersRoute
  DashboardSettingsWorkHoursRoute: typeof DashboardSettingsWorkHoursRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteRouteChildren: DashboardSettingsRouteRouteChildren =
  {
    DashboardSettingsAccountRoute: DashboardSettingsAccountRoute,
    DashboardSettingsCallsRoute: DashboardSettingsCallsRoute,
    DashboardSettingsGoogleWorkspaceRoute:
      DashboardSettingsGoogleWorkspaceRoute,
    DashboardSettingsNotificationsRoute: DashboardSettingsNotificationsRoute,
    DashboardSettingsShiftsRoute: DashboardSettingsShiftsRoute,
    DashboardSettingsUsersRoute: DashboardSettingsUsersRoute,
    DashboardSettingsWorkHoursRoute: DashboardSettingsWorkHoursRoute,
    DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  }

const DashboardSettingsRouteRouteWithChildren =
  DashboardSettingsRouteRoute._addFileChildren(
    DashboardSettingsRouteRouteChildren,
  )

interface DashboardTasksRouteRouteChildren {
  DashboardTasksContactIdRoute: typeof DashboardTasksContactIdRoute
  DashboardTasksIndexRoute: typeof DashboardTasksIndexRoute
}

const DashboardTasksRouteRouteChildren: DashboardTasksRouteRouteChildren = {
  DashboardTasksContactIdRoute: DashboardTasksContactIdRoute,
  DashboardTasksIndexRoute: DashboardTasksIndexRoute,
}

const DashboardTasksRouteRouteWithChildren =
  DashboardTasksRouteRoute._addFileChildren(DashboardTasksRouteRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardMailRouteRoute: typeof DashboardMailRouteRouteWithChildren
  DashboardMailboxRouteRoute: typeof DashboardMailboxRouteRouteWithChildren
  DashboardSettingsRouteRoute: typeof DashboardSettingsRouteRouteWithChildren
  DashboardTasksRouteRoute: typeof DashboardTasksRouteRouteWithChildren
  DashboardCallSimulationIndexRoute: typeof DashboardCallSimulationIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardMailRouteRoute: DashboardMailRouteRouteWithChildren,
  DashboardMailboxRouteRoute: DashboardMailboxRouteRouteWithChildren,
  DashboardSettingsRouteRoute: DashboardSettingsRouteRouteWithChildren,
  DashboardTasksRouteRoute: DashboardTasksRouteRouteWithChildren,
  DashboardCallSimulationIndexRoute: DashboardCallSimulationIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  SignInRouteRoute: SignInRouteRoute,
  SignInAsRoute: SignInAsRoute,
  SignOutRoute: SignOutRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
